<template>
  <or-layout>
    <a-row :gutter="[16, 16]" type="flex" justify="space-between">
      <a-col :span="16">
        <a-form layout="inline">
          <a-form-item>
            <a-select v-model="org_id" placeholder="机构" style="width: 100px;" :loading="loading">
              <a-select-option v-for="(item) in orgList" :key="item.id" :value="item.id">{{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item>
			 
            <a-select v-model="campus_id" placeholder="校区" style="width: 140px;" width="200px;" :loading="loading">
              <a-select-option v-for="(item) in campusList" :key="item.id" :value="item.id">{{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item>
            <a-select v-model="grade_id" placeholder="年级" style="width: 100px;" :loading="loading">
              <a-select-option v-for="(item) in gradeList" :key="item.id" :value="item.id">{{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item>
            <a-select v-model="exam_id" placeholder="考试科次" style="width: 420px;" :loading="loading">
              <a-select-option v-for="(item) in examList" :key="item.id" :value="item.id">{{ item.exam_title }}
              </a-select-option>
            </a-select>
          </a-form-item>

          <!--<a-form-item>-->
          <!--<a-input v-model="keyword" placeholder="名字、电话"></a-input>-->
          <!--</a-form-item>-->
          <a-form-item>
            <a-button type="primary" htmlType="submit" icon="search" @click="getTableList"></a-button>
          </a-form-item>
        </a-form>
      </a-col>
      <a-col></a-col>
    </a-row>
    <a-divider></a-divider>
    <div>
		
      <a-table :dataSource="datalist" :rowKey="item => item.id" :pagination="false" :loading="loading" bordered>
        <a-table-column key="student_info" title="班级信息">
          <template slot-scope="item">
            <span>{{ item.campus_name }}-{{ item.grade_name }}-{{item.squadinfo.name}}</span>
          </template>
        </a-table-column>
        <a-table-column key="student_name" title="名字" data-index="student_name" />
        <a-table-column key="excel_seq" title="序号" data-index="excel_seq" />
        <a-table-column key="student_score" title="总分" data-index="student_score" />
        <a-table-column key="teacher_name" title="教师名字" data-index="teacher_name" />
        <a-table-column key="jion_time" title="成绩">
          <template slot-scope="item,_,index">
            <a-form layout="inline" style="width: 600px;">
              <a-form-item label="成绩1：">
                <a-input :ref="`${index}_1`" @focus="(e) => e.currentTarget.select()" v-model="item.part_1"
                  style="width: 70px;" @pressEnter="netinput(index, 2, item)"></a-input>
              </a-form-item>
              <a-form-item label="成绩2：">
                <a-input :ref="`${index}_2`" @focus="(e) => e.currentTarget.select()" v-model="item.part_2"
                  style="width: 70px;" @pressEnter="netinput(index, 3, item)"></a-input>
              </a-form-item>
              <a-form-item label="成绩3：">
                <a-input :ref="`${index}_3`" @focus="(e) => e.currentTarget.select()" v-model="item.part_3"
                  style="width: 70px;" @pressEnter="netinput(index + 1, 1, item)"></a-input>
              </a-form-item>
              <a-button type="primary" @click="netinput(index + 1, 1, item)">提交</a-button>
            </a-form>
          </template>
        </a-table-column>

        <!--<a-table-column key="opt" title="操作">-->
        <!--<template slot-scope="item">-->
        <!--<student-home-work :user_id="item.id" :squad_id="squad_id"/>-->
        <!--&lt;!&ndash;<a-button type="primary" htmlType="submit" icon="ordered-list" @click="showHomeWorkInfo(item.id)" >查看作业</a-button>&ndash;&gt;-->
        <!--</template>-->
        <!--</a-table-column>-->
      </a-table>
    </div>

  </or-layout>
</template>

<script>

import ACol from "ant-design-vue/es/grid/Col";
import moment from "moment";

export default {
  components: { ACol },
  data() {
    return {
      keyword: undefined,
      homework_visible: false,
      video_path: undefined,
      video_visible: false,
      pageinfo: { total: 1, current: 1, pageSize: 1000 },
      loading: false,
      source_type: "mryl",
      media_path: "",
      datalist: [],
      orgList: [],
      org_id: undefined,
      campusList: [],
      squadList: [],
      campus_id: undefined,
      gradeList: [{ id:'f0ba1a33ec3c05323e85a39bb351bf54', name: '二年级' }, { id: 'a8d63f687cf09ff50c4d4b7cc090568c', name: '三年级' }, { id: '389255d8b2d214fd2a7166f113b32848', name: '四年级' }, { id: 'e2c94a56cae9c7b4c142816c80dd97ed', name: '五年级' }, {
        id: '9a32bce9b4dce97eddd5c0f8861416fc',
        name: '六年级'
      },
	  {
	    id: '11fa873ce312ab5693e689cc89d5b46a',
	    name: '七年级'
	  },
	  {
	    id: '0c7b4f40e5037b66b1efa642868eb0f2',
	    name: '八年级'
	  },
        {
          id: '27fe6228e93f1516f7d3fc087a74665f',
          name: '九年级'
        }],
      examList: [],
      grade_id: 'a8d63f687cf09ff50c4d4b7cc090568c',
      exam_id: undefined
    };
  },
  mounted() {
    this.loading = true;
    // this.getTableList();
    this.getMyOrgList();
    this.getExamInfoList();

  },
  methods: {
    netinput(index, nextid, item) {
      //代表要换行
      let _this = this;
      if (nextid == 1) {
        this.loading = true;
        this.$axios
          .post("/api/StudentExam/submit_student_score", {
            data: item
          })
          .then((res) => {
            this.loading = false;
            if (res.code != 200) {
              this.$error({
                title: "错误",
                content: res.msg,
                okText: "确定",
              });
            } else {
              item.student_score = res.data.student_score;
              if (index <= this.datalist.length) {
                _this.$refs[index + "_" + nextid].focus();
              }

            }
          })
          .catch((err) => {
            this.loading = false;
            console.error(err);
          });
      } else {
        if (index <= this.datalist.length) {
          _this.$refs[index + "_" + nextid].focus();
        }
      }
    },
    changeSquad(id) {
      this.squad_id = id;
      this.keyword = undefined;
      this.getTableList();
    },
    changeCampus(id) {
      this.campus_id = id;
      this.getMySquadList();
    },
    tableSearch() {
      this.pageinfo.current = 1;
      this.getTableList();
    },
    getTableList() {
      this.loading = true;
      this.$axios
        .post("/api/StudentExam/get_student_list", {
          data: {
            campus_id: this.campus_id,
            grade_id: this.grade_id,
            exam_id: this.exam_id
          }
        })
        .then((res) => {
          this.loading = false;
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定",
            });
          } else {
            this.datalist = res.data;
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    change_audit(data) {
      this.loading = true;
      this.$axios
        .post("/api/StudentLecture/change_audit", { data })
        .then((res) => {
          this.loading = false;
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定",
            });
          } else {
            this.getTableList();
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },

    getMyOrgList() {
      this.$axios
        .post("/api/Admin/get_my_org_list")
        .then(res => {
          this.loading = false;
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定"
            });
          } else {
            this.orgList = res.data;
            if (this.orgList.length > 0) {
              this.org_id = this.orgList[0]['id'];
              this.getMyCampusList();
            }
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    getExamInfoList() {
      this.$axios
        .post("/api/StudentExam/get_exam_info_list")
        .then(res => {
          this.loading = false;
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定"
            });
          } else {
            this.examList = res.data;
            if (this.examList.length > 0) {
              this.exam_id = this.examList[0]['id'];
            }
          }
        })
        .catch(err => {
          console.error(err);
        });
    },

    getMyCampusList() {
      this.$axios
        .post("/api/Admin/get_my_campus_list", {
          data: { org_id: this.org_id }
        })
        .then(res => {
          this.loading = false;
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定"
            });
          } else {
            this.campusList = res.data;
            if (this.campusList.length > 0) {
              this.campus_id = this.campusList[0]['id'];
              this.getMySquadList();
            }
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    getMySquadList() {
      this.$axios
        .post("/api/Admin/get_my_squad_list", {
          data: { campus_id: this.campus_id }
        })
        .then(res => {
          this.loading = false;
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定"
            });
          } else {
            this.squadList = res.data;
            if (this.squadList.length > 0) {
              this.squad_id = this.squadList[0]['id'];
              this.changeSquad(this.squad_id)
            }
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    moment
  }
}
  ;
</script>
<style>
.active_btn {
  margin-left: 5px;
}
</style>